import { useState } from "react";

// Components
import SitesDataGrid from "./SitesDataGrid";
import SiteDeleteDialog from "./SiteDeleteDialog";
import SiteDrawer from "./SiteDrawer";

import { SelectedSitesContext } from "../context/SelectedSiteContext";
import SitesToolbar from "./SitesToolbar";

function Sites() {
  const [isCreatorOpen, setIsCreatorOpen] = useState(false);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [isRemoverOpen, setIsRemoverOpen] = useState(false);

  return (
    <SelectedSitesContext>
      <SitesToolbar
        setIsAddOpen={setIsCreatorOpen}
        setIsEditOpen={setIsEditorOpen}
        setIsRemoverOpen={setIsRemoverOpen}
      />
      <div style={{ flex: 1, overflowY: "auto" }}>
        <SitesDataGrid data-testid="sites-toolbar" />
      </div>
      <SiteDrawer isOpen={isCreatorOpen} setIsOpen={setIsCreatorOpen} newSite={true} />
      <SiteDrawer isOpen={isEditorOpen} setIsOpen={setIsEditorOpen} />
      {isRemoverOpen && <SiteDeleteDialog isOpen={isRemoverOpen} setIsOpen={setIsRemoverOpen} />}
    </SelectedSitesContext>
  );
}

export default Sites;
